/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Rtx.Verbum.Api | v1
 * OpenAPI spec version: 1.0.0
 */

import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query'
import { useMutation, useQuery } from '@tanstack/react-query'
import { customInstance } from '../../../../core/custom-instance'
import type {
  DataEnvelopeOfCommunicationTemplateDto,
  DataEnvelopeOfObject,
  DataPaginationEnvelopeOfCommunicationTemplateDto,
  DeleteCommunicationTemplateParams,
  ErrorEnvelope,
  ListCommunicationTemplatesParams,
  SaveCommunicationTemplateDto,
} from '../model'

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1]

const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K }
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    })
  }
  return result
}

/**
 * @summary Lista modelos de conteúdo da organização (Gestor ou Admin)
 */
export const listCommunicationTemplates = (
  params?: ListCommunicationTemplatesParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<DataPaginationEnvelopeOfCommunicationTemplateDto>(
    { url: `/v1/communication-templates`, method: 'GET', params, signal },
    options,
  )
}

export const getListCommunicationTemplatesQueryKey = (
  params?: ListCommunicationTemplatesParams,
) => {
  return [`/v1/communication-templates`, ...(params ? [params] : [])] as const
}

export const getListCommunicationTemplatesQueryOptions = <
  TData = Awaited<ReturnType<typeof listCommunicationTemplates>>,
  TError = ErrorEnvelope,
>(
  params?: ListCommunicationTemplatesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listCommunicationTemplates>>, TError, TData>
    >
    request?: SecondParameter<typeof customInstance>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getListCommunicationTemplatesQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listCommunicationTemplates>>> = ({
    signal,
  }) => listCommunicationTemplates(params, requestOptions, signal)

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listCommunicationTemplates>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListCommunicationTemplatesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listCommunicationTemplates>>
>
export type ListCommunicationTemplatesQueryError = ErrorEnvelope

export function useListCommunicationTemplates<
  TData = Awaited<ReturnType<typeof listCommunicationTemplates>>,
  TError = ErrorEnvelope,
>(
  params: undefined | ListCommunicationTemplatesParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listCommunicationTemplates>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listCommunicationTemplates>>,
          TError,
          Awaited<ReturnType<typeof listCommunicationTemplates>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListCommunicationTemplates<
  TData = Awaited<ReturnType<typeof listCommunicationTemplates>>,
  TError = ErrorEnvelope,
>(
  params?: ListCommunicationTemplatesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listCommunicationTemplates>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listCommunicationTemplates>>,
          TError,
          Awaited<ReturnType<typeof listCommunicationTemplates>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListCommunicationTemplates<
  TData = Awaited<ReturnType<typeof listCommunicationTemplates>>,
  TError = ErrorEnvelope,
>(
  params?: ListCommunicationTemplatesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listCommunicationTemplates>>, TError, TData>
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista modelos de conteúdo da organização (Gestor ou Admin)
 */

export function useListCommunicationTemplates<
  TData = Awaited<ReturnType<typeof listCommunicationTemplates>>,
  TError = ErrorEnvelope,
>(
  params?: ListCommunicationTemplatesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listCommunicationTemplates>>, TError, TData>
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListCommunicationTemplatesQueryOptions(params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

/**
 * @summary Salva conteúdo sanitizado como modelo, sem publicar comunicado
 */
export const createCommunicationTemplate = (
  saveCommunicationTemplateDto: SaveCommunicationTemplateDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<DataEnvelopeOfCommunicationTemplateDto>(
    {
      url: `/v1/communication-templates`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: saveCommunicationTemplateDto,
      signal,
    },
    options,
  )
}

export const getCreateCommunicationTemplateMutationKey = () =>
  ['createCommunicationTemplate'] as const

export const getCreateCommunicationTemplateMutationOptions = <
  TError = ErrorEnvelope,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createCommunicationTemplate>>,
    TError,
    CreateCommunicationTemplateMutationVariables,
    TContext
  >
  request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
  Awaited<ReturnType<typeof createCommunicationTemplate>>,
  TError,
  CreateCommunicationTemplateMutationVariables,
  TContext
> => {
  const mutationKey = getCreateCommunicationTemplateMutationKey()
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createCommunicationTemplate>>,
    CreateCommunicationTemplateMutationVariables
  > = (props) => {
    const { data } = props ?? {}

    return createCommunicationTemplate(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type CreateCommunicationTemplateMutationResult = NonNullable<
  Awaited<ReturnType<typeof createCommunicationTemplate>>
>
export type CreateCommunicationTemplateMutationBody = SaveCommunicationTemplateDto
export type CreateCommunicationTemplateMutationError = ErrorEnvelope
export type CreateCommunicationTemplateMutationVariables = { data: SaveCommunicationTemplateDto }

/**
 * @summary Salva conteúdo sanitizado como modelo, sem publicar comunicado
 */
export const useCreateCommunicationTemplate = <TError = ErrorEnvelope, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createCommunicationTemplate>>,
      TError,
      CreateCommunicationTemplateMutationVariables,
      TContext
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createCommunicationTemplate>>,
  TError,
  CreateCommunicationTemplateMutationVariables,
  TContext
> => {
  return useMutation(getCreateCommunicationTemplateMutationOptions(options), queryClient)
}
/**
 * @summary Consulta um modelo da organização (Gestor ou Admin)
 */
export const getCommunicationTemplate = (
  id: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<DataEnvelopeOfCommunicationTemplateDto>(
    { url: `/v1/communication-templates/${id}`, method: 'GET', signal },
    options,
  )
}

export const getGetCommunicationTemplateQueryKey = (id: string) => {
  return [`/v1/communication-templates/${id}`] as const
}

export const getGetCommunicationTemplateQueryOptions = <
  TData = Awaited<ReturnType<typeof getCommunicationTemplate>>,
  TError = ErrorEnvelope,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCommunicationTemplate>>, TError, TData>
    >
    request?: SecondParameter<typeof customInstance>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetCommunicationTemplateQueryKey(id)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCommunicationTemplate>>> = ({
    signal,
  }) => getCommunicationTemplate(id, requestOptions, signal)

  return {
    queryKey,
    queryFn,
    enabled: id !== null && id !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getCommunicationTemplate>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }
}

export type GetCommunicationTemplateQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCommunicationTemplate>>
>
export type GetCommunicationTemplateQueryError = ErrorEnvelope

export function useGetCommunicationTemplate<
  TData = Awaited<ReturnType<typeof getCommunicationTemplate>>,
  TError = ErrorEnvelope,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCommunicationTemplate>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCommunicationTemplate>>,
          TError,
          Awaited<ReturnType<typeof getCommunicationTemplate>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCommunicationTemplate<
  TData = Awaited<ReturnType<typeof getCommunicationTemplate>>,
  TError = ErrorEnvelope,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCommunicationTemplate>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCommunicationTemplate>>,
          TError,
          Awaited<ReturnType<typeof getCommunicationTemplate>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCommunicationTemplate<
  TData = Awaited<ReturnType<typeof getCommunicationTemplate>>,
  TError = ErrorEnvelope,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCommunicationTemplate>>, TError, TData>
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Consulta um modelo da organização (Gestor ou Admin)
 */

export function useGetCommunicationTemplate<
  TData = Awaited<ReturnType<typeof getCommunicationTemplate>>,
  TError = ErrorEnvelope,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCommunicationTemplate>>, TError, TData>
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetCommunicationTemplateQueryOptions(id, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

/**
 * @summary Atualiza modelo com controle de versão
 */
export const updateCommunicationTemplate = (
  id: string,
  saveCommunicationTemplateDto: SaveCommunicationTemplateDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<DataEnvelopeOfCommunicationTemplateDto>(
    {
      url: `/v1/communication-templates/${id}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: saveCommunicationTemplateDto,
      signal,
    },
    options,
  )
}

export const getUpdateCommunicationTemplateMutationKey = () =>
  ['updateCommunicationTemplate'] as const

export const getUpdateCommunicationTemplateMutationOptions = <
  TError = ErrorEnvelope,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateCommunicationTemplate>>,
    TError,
    UpdateCommunicationTemplateMutationVariables,
    TContext
  >
  request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateCommunicationTemplate>>,
  TError,
  UpdateCommunicationTemplateMutationVariables,
  TContext
> => {
  const mutationKey = getUpdateCommunicationTemplateMutationKey()
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateCommunicationTemplate>>,
    UpdateCommunicationTemplateMutationVariables
  > = (props) => {
    const { id, data } = props ?? {}

    return updateCommunicationTemplate(id, data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type UpdateCommunicationTemplateMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateCommunicationTemplate>>
>
export type UpdateCommunicationTemplateMutationBody = SaveCommunicationTemplateDto
export type UpdateCommunicationTemplateMutationError = ErrorEnvelope
export type UpdateCommunicationTemplateMutationVariables = {
  id: string
  data: SaveCommunicationTemplateDto
}

/**
 * @summary Atualiza modelo com controle de versão
 */
export const useUpdateCommunicationTemplate = <TError = ErrorEnvelope, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateCommunicationTemplate>>,
      TError,
      UpdateCommunicationTemplateMutationVariables,
      TContext
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateCommunicationTemplate>>,
  TError,
  UpdateCommunicationTemplateMutationVariables,
  TContext
> => {
  return useMutation(getUpdateCommunicationTemplateMutationOptions(options), queryClient)
}
/**
 * @summary Exclui modelo pela versão informada na query, preservando comunicados
 */
export const deleteCommunicationTemplate = (
  id: string,
  params: DeleteCommunicationTemplateParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<DataEnvelopeOfObject>(
    { url: `/v1/communication-templates/${id}`, method: 'DELETE', params, signal },
    options,
  )
}

export const getDeleteCommunicationTemplateMutationKey = () =>
  ['deleteCommunicationTemplate'] as const

export const getDeleteCommunicationTemplateMutationOptions = <
  TError = ErrorEnvelope,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteCommunicationTemplate>>,
    TError,
    DeleteCommunicationTemplateMutationVariables,
    TContext
  >
  request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteCommunicationTemplate>>,
  TError,
  DeleteCommunicationTemplateMutationVariables,
  TContext
> => {
  const mutationKey = getDeleteCommunicationTemplateMutationKey()
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteCommunicationTemplate>>,
    DeleteCommunicationTemplateMutationVariables
  > = (props) => {
    const { id, params } = props ?? {}

    return deleteCommunicationTemplate(id, params, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type DeleteCommunicationTemplateMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteCommunicationTemplate>>
>

export type DeleteCommunicationTemplateMutationError = ErrorEnvelope
export type DeleteCommunicationTemplateMutationVariables = {
  id: string
  params: DeleteCommunicationTemplateParams
}

/**
 * @summary Exclui modelo pela versão informada na query, preservando comunicados
 */
export const useDeleteCommunicationTemplate = <TError = ErrorEnvelope, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteCommunicationTemplate>>,
      TError,
      DeleteCommunicationTemplateMutationVariables,
      TContext
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteCommunicationTemplate>>,
  TError,
  DeleteCommunicationTemplateMutationVariables,
  TContext
> => {
  return useMutation(getDeleteCommunicationTemplateMutationOptions(options), queryClient)
}
